import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { openDrawer } from 'features/drawersSlice';
import { isMobileDeviceRequest } from 'lib';

const MAX_TRIES = 10;

// attach click event to non react element in order to big widget
const useOpenBigWidget = () => {
    const dispatch = useDispatch();

    const widgetReady = useSelector(
        (state) => state.miniBookingWidget.widgetReady
    );
    const selectors =
        useSelector(
            (state) => state.miniBookingWidget.openBigWidgetElmSelectors
        ) || [];
    const mobileRequest = isMobileDeviceRequest();
    const attachEvent = (selector, listener, tries) => {
        // reached max tries, we need to stop
        if (tries === 0) {
            return;
        }

        const elms = document.querySelectorAll(selector);

        // element is not present in the DOM retry again after 1000ms
        if (!elms) {
            setTimeout(() => attachEvent(selector, listener, tries - 1), 1000);
        }

        if (elms.length > 0) {
            elms.forEach((elm) => {
                elm.addEventListener('click', listener);
            });
        }
    };

    useEffect(() => {
        // widget has not loaded yet
        if (!widgetReady) {
            return;
        }

        selectors.forEach((selector) => {
            attachEvent(
                selector,
                () => {
                    if (mobileRequest) {
                        dispatch(
                            openDrawer({
                                drawerId: 'MobileMultipropertyDrawer',
                            })
                        );
                    } else {
                        dispatch(
                            openDrawer({ drawerId: 'BigBookingWidgetDrawer' })
                        );
                    }
                },
                MAX_TRIES
            );
        });
    }, [widgetReady]);
};

export default useOpenBigWidget;
